// Add background to home scrolled Header
var headerHome = function(){

	var waiting = false, endScrollHandle;

//   var headerOnScroll = function(){
//         var scrollPos         = $(window).scrollTop();
//         var getsScrolledClass = $('.tv-header');

// 	 	if(scrollPos > 1){
// 			getsScrolledClass.addClass('tv-header--scrolled');
// 		}else{
// 			getsScrolledClass.removeClass('tv-header--scrolled');
// 		}
// 	};

	// headerOnScroll();

//   $(window).scroll(function(){

//       if (waiting){return;}

// 		waiting = true;
// 		clearTimeout(endScrollHandle);

// 		headerOnScroll();

// 		setTimeout(function(){
// 			waiting = false;
// 		}, 100);

// 		endScrollHandle = setTimeout(function(){
// 			headerOnScroll();
// 		}, 200);

//   });

}

// Video switch

var videoSwitch = function(){

	var vSwitch    = $('.tv-js-homeVideo-videoSwitch');
	var vSoundSwitchOn = $('.tv-js-homeVideo-videoSoundSwitch--on');
	var vSoundSwitchMute = $('.tv-js-homeVideo-videoSoundSwitch--mute');
	var video      = $('.tv-homeVideo-video video');
	var getsPaused = $('.tv-homeVideo');
	var videoState = 1;

	vSwitch.on('click', function(){
		if(videoState == 1){
        	video.get(0).pause();
			videoState = 0;
			getsPaused.addClass('tv-homeVideo--paused');
		}else{
			video.get(0).play();
			videoState = 1;
			getsPaused.removeClass('tv-homeVideo--paused');
		}
  });

	vSoundSwitchOn.on('click', function(){
		vSoundSwitchOn.hide();
		vSoundSwitchMute.show();
		video.get(0).muted = false;
	});

	vSoundSwitchMute.on('click', function(){
		vSoundSwitchOn.show();
		vSoundSwitchMute.hide();
		video.get(0).muted = true;
	});

}

var videoStoreSwitch = function(){

	var vSwitch    = $('.tv-js-storeVideo-videoSwitch');
	var vSoundSwitchOn = $('.tv-js-storeVideo-videoSoundSwitch--on');
	var vSoundSwitchMute = $('.tv-js-storeVideo-videoSoundSwitch--mute');
	var video      = $('.tv-storeVideo-video video');
	var getsPaused = $('.tv-storeVideo');
	var videoState = 1;

	vSwitch.on('click', function(){
		if(videoState == 1){
        	video.get(0).pause();
			videoState = 0;
			getsPaused.addClass('tv-storeVideo--paused');
		}else{
			video.get(0).play();
			videoState = 1;
			getsPaused.removeClass('tv-storeVideo--paused');
		}
  });

	vSoundSwitchOn.on('click', function(){
		vSoundSwitchOn.hide();
		vSoundSwitchMute.show();
		video.get(0).muted = false;
	});

	vSoundSwitchMute.on('click', function(){
		vSoundSwitchOn.show();
		vSoundSwitchMute.hide();
		video.get(0).muted = true;
	});

}

// Video source per device

var videoByDevice = function(){

	var video = $('.tv-homeVideo-video video, .tv-storeVideo video');

	if(video.length){
		if($(window).width() >= 1024){
			video[0].src = video[0].dataset.videoDesktop;
		}
		else if($(window).width() >= 768){
			video[0].src = video[0].dataset.videoTablet;
		}

		video[0].muted = true;
		video[0].load();
	  video[0].onloadeddata = function(){
			video[0].play();
		}
	}
}

// Homepage slider text display

var homepageSliderText = function() {

	var slide1 = $('.tv-home-slider .lSPager li:first');
	var slide2 = $('.tv-home-slider .lSPager li:eq(1)');
	var slide3 = $('.tv-home-slider .lSPager li:last');
	$('.tv-home-slider-title-wrapper li').removeClass('active');
	if (slide1.hasClass('active')) {
		$('.tv-home-slider-title-1').addClass('active');
	}
	if (slide2.hasClass('active')) {
		$('.tv-home-slider-title-2').addClass('active');
	}
	if (slide3.hasClass('active')) {
		$('.tv-home-slider-title-3').addClass('active');
	}
}

$(document).ready(function(){
	videoByDevice();
  	headerHome();
	videoSwitch();
	videoStoreSwitch();
	// homepageSliderText();

	$('#tv-home-lightslider').lightSlider({
		item: 1,
		loop: true,
		auto: true,
		speed: 900,
		pause: 5000,
		onSliderLoad: function (el) {
			homepageSliderText();
		},
		onAfterSlide: function (el) {
			homepageSliderText();
		},
	});
	const mybutton = $(".tv-icon-top").first();

	// When the user scrolls down 20px from the top of the document, show the button
	window.onscroll = function() {scrollFunction()};

	function scrollFunction() {
	if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
		mybutton.show();
	} else {
		mybutton.hide();
	}
	}
	$(".tv-icon-top").on('click', function() {
		$("html, body").animate({ scrollTop: 0 }, 600);
	});
});
